import { debounce } from "../utils/debounce";

const dispatchResizeEvent = () => {
    window.dispatchEvent(new Event("resize"));
};

const dispatchResizeDebounced = debounce(dispatchResizeEvent, 100);

const applyFlickityFixes = () => {
    // Wait 3 seconds for flickity
    window.setTimeout(() => {
        const targets = document.querySelectorAll(".flickity-enabled");
        if (targets.length === 0) {
            return;
        }
        dispatchResizeDebounced();
        targets.forEach((target) => {
            target.addEventListener("change.flickity", dispatchResizeDebounced);
        });
    }, 3000);
};

const applyExcentosFixes = () => {
    // Wait 3 seconds for excentos
    window.setTimeout(() => {
        const xcApp = document.getElementById("xc_application");
        if (xcApp !== null) {
            xcApp.addEventListener("click", dispatchResizeDebounced);
        }
    }, 3000);
};

const applyPatternlabFixes = () => {
    applyFlickityFixes();
    applyExcentosFixes();
};

export default applyPatternlabFixes;
